(() => {
  const DESKTOP_MQ = "(min-width: 768px)";
  const instances = new Map();

  /* ======================================================
     POSITION DES BOUTONS FLOTTANTS
     → 1 seule rangée : chaque bouton sous le centre de sa card
     → plusieurs rangées (2x2, tablette…) : répartis sur la
       largeur de la grille, sinon ils se superposeraient
  ====================================================== */
  function placeFloatingButtons(section) {
    const grid = section.querySelector(".standard-cards__grid");
    const cards = [...section.querySelectorAll(".standard-card")].filter((card) =>
      card.querySelector("[data-floating-button]")
    );
    if (!grid || !cards.length) return;

    const singleRow = new Set(cards.map((card) => card.offsetTop)).size === 1;
    const gridRect = grid.getBoundingClientRect();

    cards.forEach((card, i) => {
      let x;
      if (singleRow) {
        const rect = card.getBoundingClientRect();
        x = rect.left + rect.width / 2;
      } else {
        x = gridRect.left + (gridRect.width * (i + 0.5)) / cards.length;
      }
      card
        .querySelector("[data-floating-button]")
        .style.setProperty("--float-x", `${x}px`);
    });
  }

  /* ======================================================
     SETUP (desktop + tablette only, via gsap.matchMedia)
     → tout est annulé automatiquement sous 768px
  ====================================================== */
  function setup(section) {
    const buttons = section.querySelectorAll("[data-floating-button]");
    if (!buttons.length) return;

    const setFloating = (floating) => {
      buttons.forEach((btn) => {
        btn.classList.toggle("is-floating", floating);
        btn.classList.toggle("is-in-card", !floating);
      });
    };

    // fade out → changement d'état → fade in
    const swap = (floating) => {
      gsap.to(buttons, {
        opacity: 0,
        duration: 0.2,
        ease: "power1.out",
        overwrite: true,
        onComplete: () => {
          setFloating(floating);
          gsap.to(buttons, { opacity: 1, duration: 0.25, ease: "power1.out" });
        }
      });
    };

    /* ÉTAT INITIAL : boutons dans la card, invisibles */
    setFloating(false);
    gsap.set(buttons, { opacity: 0 });
    placeFloatingButtons(section);

    /* TRIGGER GLOBAL (PAGE) → boutons flottants */
    ScrollTrigger.create({
      trigger: document.body,
      start: "top+=35% top",
      end: () => section.offsetTop,

      onEnter: () => {
        setFloating(true);
        gsap.to(buttons, {
          opacity: 1,
          duration: 0.4,
          ease: "power2.out",
          stagger: 0.05,
          overwrite: true
        });
      },

      onLeaveBack: () => {
        gsap.to(buttons, {
          opacity: 0,
          duration: 0.3,
          ease: "power2.in",
          overwrite: true,
          onComplete: () => setFloating(false)
        });
      }
    });

    /* TRIGGER SECTION → boutons posés sur les cards */
    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: "bottom top",
      onEnter: () => swap(false),
      onLeaveBack: () => swap(true)
    });

    // ScrollTrigger se rafraîchit au resize / chargement des images
    const onRefresh = () => placeFloatingButtons(section);
    ScrollTrigger.addEventListener("refresh", onRefresh);

    return () => {
      ScrollTrigger.removeEventListener("refresh", onRefresh);
      buttons.forEach((btn) => btn.classList.remove("is-floating", "is-in-card"));
    };
  }

  function mount(root) {
    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);

    root.querySelectorAll(".standard-cards").forEach((section) => {
      instances.get(section)?.revert();
      const mm = gsap.matchMedia();
      mm.add(DESKTOP_MQ, () => setup(section));
      instances.set(section, mm);
    });
  }

  function unmount(root) {
    root.querySelectorAll(".standard-cards").forEach((section) => {
      instances.get(section)?.revert();
      instances.delete(section);
    });
  }

  document.addEventListener("DOMContentLoaded", () => mount(document));

  /* Éditeur de thème Shopify */
  document.addEventListener("shopify:section:load", (e) => mount(e.target));
  document.addEventListener("shopify:section:unload", (e) => unmount(e.target));
})();
